export * from './components/UserMessage/index';
//# sourceMappingURL=UserMessage.js.map